import { collection, getDocs } from 'firebase/firestore';
import {db} from '../../Firebase';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Book() {
const [books, setBooks] = React.useState([]);

  React.useEffect(()=>{
    const fetchBooks = async () => {
      try{
        const querySnapshot = await getDocs(collection(db, "books"));
        const bookData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setBooks(bookData);

      }catch(error){
        console.error("Error fetching books:", error);
      }
  }
  fetchBooks();
},[])

  const navigate = useNavigate();

  const handleClick = (bookId) => {
    navigate(`/audio/${bookId}`)
  };


const bookElements = books.map((book, index)=>{
  return (
  
    <div className="book-card" key={index} onClick={()=>handleClick(book.id)}>
                    <img

                    src={book.bookimg}
                    alt={book.title}
                    className="book-image"
                    />
                    <p className="book-title">{book.title}</p>
                    <p className="book-author">{book.author}</p>
                </div>
  )
})

    return (
        <>{bookElements}</>
    )

}